module.exports = __webpack_public_path__ + "static/media/mcm_502.715f7fe9.ico";